import Sidennav from "./dashboard/sidenavbar";
import Topnavbar from "./dashboard/topnavbar";
const Unauthorized = () => (
  <div style={{ display: "flex" }}>
    <Sidennav />

    <div style={{ flex: 1 }}>
      <Topnavbar />
      <div style={{ padding: "2rem", textAlign: "center" }}>
        <h2>403 - Unauthorized Page</h2>
        <p>You do not have permission to access this page.</p>
      </div>
    </div>
  </div>
);

export default Unauthorized;
